import type { IconsList as Icons } from '@mint-lib/icons/allIcons';
import styled from '@mint-lib/styled';

import AccordionSummaryBasic, {
  AccordionSummaryBasicProps,
} from '../AccordionSummaryBasic/AccordionSummaryBasic.jsx';
import Icon, { IconProps } from '../Icon/Icon.jsx';
import Typography from '../Typography/Typography.jsx';

export interface AccordionSummaryProps extends AccordionSummaryBasicProps {
  /**
   * The icon to display as the expand indicator.
   * Icon prop is used to improve Merge usability.
   */
  expandedIcon?: Icons;
  description?: string;
  warningIcon?: boolean;
  icon?: Icons;
  iconProps?: Partial<IconProps>;
}

/**
 * @deprecated Use Accordion components from @mint-lib/tw-components instead
 */
function AccordionSummary({
  description,
  icon,
  iconProps,
  warningIcon,
  ...props
}: AccordionSummaryProps) {
  return (
    <AccordionSummaryBasic
      {...props}
      sx={{ padding: '5px 12px' }}
      expandIcon={
        props.expandedIcon ? (
          <Icon
            component={props.expandedIcon}
            sx={{ color: 'icon.secondary' }}
          />
        ) : (
          <Icon
            component="ChevronDown"
            color="inherit"
            aria-label="chevron-icon"
          />
        )
      }
    >
      <FlexContainer>
        <Container>
          <InnerContainer>
            <Typography component="p" variant="bodyShort02">
              {props.children}
            </Typography>
            {warningIcon && (
              <Icon
                sx={{ marginLeft: '4px' }}
                component="WarningAltFilled"
                color="warning"
                aria-label="warning-icon"
              />
            )}
            {icon && (
              <Icon
                sx={{ marginLeft: '4px' }}
                {...iconProps}
                component={icon}
              />
            )}
          </InnerContainer>
          {description && (
            <Typography variant="caption02" color="text.secondary">
              {description}
            </Typography>
          )}
        </Container>
      </FlexContainer>
    </AccordionSummaryBasic>
  );
}
export default AccordionSummary;

const InnerContainer = styled('div')(({ theme }) => ({
  ' .MuiTypography-root': {
    ...theme.typography.bodyShort02,
  },
  display: 'flex',
  alignItems: 'center',
}));
const FlexContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});
const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});
